import { render } from "./layer.vue?vue&type=template&id=146a03aa"
import script from "./layer.vue?vue&type=script&lang=js"
export * from "./layer.vue?vue&type=script&lang=js"

import "./layer.vue?vue&type=style&index=0&id=146a03aa&lang=css"

import exportComponent from "D:\\workspace_front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__